import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Styles from "./InstallPWAPrompt.module.css";
import { isPWA, isMobileView } from "../../Utility/Utility";

const DISMISS_KEY = "pwaInstallDismissed";

function isIos() {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}

function wasDismissedThisSession() {
  return sessionStorage.getItem(DISMISS_KEY) === "true";
}

function ShareIcon() {
  return (
    <svg
      className={Styles.iosIcon}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 3v12M12 3l-3.5 3.5M12 3l3.5 3.5"
        stroke="#007AFF"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8"
        stroke="#007AFF"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AddToHomeScreenIcon() {
  return (
    <svg
      className={Styles.iosIcon}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
        stroke="#333"
        strokeWidth="1.8"
      />
      <path
        d="M12 7.5v9M7.5 12h9"
        stroke="#333"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function InstallPWAPrompt() {
  const logoDetails = useSelector((state) => state.logo_details);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [showIosBanner, setShowIosBanner] = useState(false);

  const appName = logoDetails?.name?.trim() || "KSTORe";
  const appIcon =
    logoDetails?.logo192 || logoDetails?.logo || "/logo192.png";

  useEffect(() => {
    if (isPWA() || !isMobileView || wasDismissedThisSession()) {
      return;
    }

    if (isIos()) {
      setShowIosBanner(true);
      return;
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "true");
    setShowBanner(false);
    setShowIosBanner(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  if (!showBanner && !showIosBanner) return null;

  return (
    <div className={Styles.installBanner}>
      <div className={Styles.installContent}>
        <img
          className={Styles.installIcon}
          src={appIcon}
          alt="App icon"
        />
        <div className={Styles.installTextContainer}>
          <p className={Styles.installTitle}>Install {appName} App</p>
          {showIosBanner ? (
            <p className={`${Styles.installText} ${Styles.installTextIos}`}>
              Tap <ShareIcon /> <strong>Share</strong> then{" "}
              <AddToHomeScreenIcon /> <strong>Add to Home Screen</strong>
            </p>
          ) : (
            <p className={Styles.installText}>
              Add to your home screen for quick access
            </p>
          )}
        </div>
      </div>
      <div className={Styles.installActions}>
        {showBanner && (
          <button className={Styles.installBtn} onClick={handleInstall}>
            Install
          </button>
        )}
        <button
          className={Styles.closeBtn}
          onClick={handleDismiss}
          aria-label="Close"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
